<template>
    <v-container fluid grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12>
                <basic :infoBasic="item"/>
            </v-flex>

           <v-flex xs12 d-flex>
                <paper-manage :infoBasic="item"/>
            </v-flex>

            <v-flex xs12 d-flex>
                <proj-manage :infoBasic="item"/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters} from 'vuex'
    import Basic from './basic'
    import PaperManage from "./paperManage";
    import ProjManage from "./projManage";

    const baseUri = '/api/integrity/integrity';
    export default {
        components: {ProjManage, PaperManage, Basic},
        data: () => ({
            item: {}
        }),

        // 路由进入前，组件就未完成渲染，不可以使用 this
        beforeRouteEnter(to, from, next) {
            window.console.log("In edit_page beforeRouteEnter");
            const dbid = to.params.dbid;
            if (dbid.length>0 ) {
                Vue.axios.get(`${baseUri}/${dbid}`)
                    .then(
                        rsp => next(vm => {
                            vm.dbid = dbid;
                            vm.item = rsp.data;
                            // 保存默认数据
                            vm.defaultItem = window.xutil.clone(vm.item);
                            vm.loading = false
                        })
                    )
            } else {
                next();
            }
        },

        // 路由改变前，组件就已经渲染完成，可以使用 this
        beforeRouteUpdate(to, from, next) {
            window.console.log("In edit_page beforeRouteUpdate");
            const dbid = to.params.dbid;
            if (dbid.length>0 ) {
                this.loading = true;
                Vue.axios.get(`${baseUri}/${dbid}`)
                    .then(
                        rsp => {
                            this.dbid = dbid;
                            this.item = rsp.data;
                            // 保存默认数据
                            this.defaultItem = window.xutil.clone(this.item);
                            this.loading = false;
                            next()
                        }
                    )
            } else {
                next();
            }
        },

        computed: {
            ...mapGetters(['funcIds'])
        },

        created() {
        },

        methods: {
        }
    }
</script>
<style>
    div.dense table.datatable.table td:first-child,
    div.dense table.datatable.table td:not(:first-child),
    div.dense table.datatable.table th:first-child,
    div.dense table.datatable.table th:not(:first-child) {
        padding: 0 8px;
    }
</style>